/* unplugin-vue-components disabled */import script from "./CompetitionSubmitDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionSubmitDialog.vue?vue&type=script&setup=true&lang=js"

import "./CompetitionSubmitDialog.vue?vue&type=style&index=0&id=2def5ccc&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2def5ccc"]])

export default __exports__